import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

import "./ErrorPage.scss";

export default function ErrorPage() {
  const navigate = useNavigate();

  return (
    <Box className="nf">
      {/* Background blobs */}
      <div className="nf__blob nf__blob--a" aria-hidden="true" />
      <div className="nf__blob nf__blob--b" aria-hidden="true" />
      <div className="nf__grid" aria-hidden="true" />

      <Paper className="nf__card" elevation={0}>
        <Stack spacing={2.2}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Chip
              className="nf__chip"
              icon={<SearchRoundedIcon />}
              label="Page not found"
              variant="outlined"
            />
          </Stack>

          <Stack direction="row" spacing={2} alignItems="flex-end" className="nf__hero">
            {/* <Typography className="nf__code" component="div">
              404
            </Typography> */}

            <Stack spacing={0.6} className="nf__copy">
              <Typography variant="h4" className="nf__title">
                Oops — this page went missing
              </Typography>
              <Typography variant="body1" className="nf__subtitle">
                The link may be broken, or the username doesn’t exist. Try going back or head to the homepage.
              </Typography>
            </Stack>
          </Stack>

          {/* <Stack direction={{ xs: "column", sm: "row" }} spacing={1.2} className="nf__actions">
            <Button
              variant="contained"
              size="large"
              startIcon={<ArrowBackRoundedIcon />}
              onClick={() => navigate(-1)}
              className="nf__btn nf__btn--primary"
            >
              Go back
            </Button>

            <Button
              variant="outlined"
              size="large"
              startIcon={<HomeRoundedIcon />}
              onClick={() => navigate("/")}
              className="nf__btn"
            >
              Home
            </Button>
          </Stack> */}

          <Typography variant="caption" className="nf__hint">
            Tip: double-check the URL spelling.
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
}